import React from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'
import { darken } from 'polished'

const Wrapper = styled.button.attrs({
  className:
    'db primary-font-bold tc pv3 ph4 f4 f3-ns ma3 h4 w4 input-reset bn pointer primary-font-bold'
})`
  transition: background .2s;
  color: ${props => (props.negative ? '#fff' : props.theme.secondaryColor)};
  background-color: ${props => (props.negative ? props.theme.secondaryColor : '#fff')};
  outline: none;
  border-radius: ${props => (props.pill ? '9999px' : '100%')};
  height: ${props => (props.pill ? 'auto' : '8rem')};
  width: ${props => (props.pill ? '80%' : '8rem')};
  :hover {
    background-color: ${props =>
    props.negative ? darken(0.2, props.theme.secondaryColor) : darken(0.1, '#fff')};
  }
`

const Button = ({ children, ...rest }) =>
  <Wrapper {...rest}>
    {children}
  </Wrapper>

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
    .isRequired
}

export default withTheme(Button)



// WEBPACK FOOTER //
// ./src/components/Button/Button.js